import React, { useCallback, useEffect, useState } from "react";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";

import { ApiSearch } from "components/ApiSearch";
import { Button } from "components/Button";
import { PageWithNav } from "components/PageWithNav";
import { Pagination } from "components/Pagination";
import { Spinner } from "components/Spinner";
import { Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow } from "components/Table";
import api from "utils/api";

export const Students = () => {
  const navigate = useNavigate();
  const [students, setStudents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pagination, setPagination] = useState({});

  const loadStudents = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await api.get("/students", {
        params: {
          search,
          page: currentPage,
        },
      });
      setStudents(response.data.data);
      setPagination({ totalPages: response.data.last_page, total: response.data.total, start: response.data.from, end: response.data.to });
    } finally {
      setIsLoading(false);
    }
  }, [search, currentPage]);

  useEffect(() => {
    loadStudents();
  }, [loadStudents]);

  return (
    <PageWithNav>
      <div className="mb-5 flex flex-col justify-between sm:flex-row md:flex-row md:items-center">
        <h1 className="w-full pe-4 text-xl font-semibold text-neutral-900">Students</h1>
        <ApiSearch onChange={setSearch} />
      </div>

      {isLoading && (
        <div className="flex justify-center">
          <Spinner size="lg" color="primary" />
        </div>
      )}
      {!isLoading && (
        <>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHeaderCell className="w-[0%]">ID</TableHeaderCell>
                <TableHeaderCell>Name</TableHeaderCell>
                <TableHeaderCell>Email</TableHeaderCell>
                <TableHeaderCell>Registered At</TableHeaderCell>
                <TableHeaderCell />
              </TableRow>
            </TableHeader>
            <TableBody emptyColSpan={5}>
              {!!students.length &&
                students.map((student) => (
                  <TableRow key={student.id.toString()} className={`${student.needs_certification && "odd:bg-yellow-50 even:bg-yellow-50"}`}>
                    <TableCell className="font-semibold">{student.id}</TableCell>
                    <TableCell>{student.name}</TableCell>
                    <TableCell>{student.email}</TableCell>
                    <TableCell>{format(student.created_at, "do MMM yyyy")}</TableCell>
                    <TableCell className="w-0">
                      <Button size="sm" onClick={() => navigate(`/students/view/${student.id}`)}>
                        View
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
          <Pagination currentPage={currentPage} totalPages={pagination.totalPages} start={pagination.start} end={pagination.end} total={pagination.total} onPageChange={setCurrentPage} />
        </>
      )}
    </PageWithNav>
  );
};
